import { useCallback, useMemo, useState } from "react";
import { useIndividualAccount } from "../../../Hooks/useIndividualAccount";
import {
  isPersonStatusVerified,
  resolvePersonStatus,
} from "../../../Utils/accountKycStatus";

export const useHomeIndividualAccount = (accountData = {}) => {
  const [onboardingOpen, setOnboardingOpen] = useState(false);
  const individualAccount = useIndividualAccount();

  const openOnboarding = useCallback(() => {
    setOnboardingOpen(true);
  }, []);

  const closeOnboarding = useCallback(() => {
    setOnboardingOpen(false);
  }, []);

  // Prefer /v1/ib/accounts/me person_status — banner when !== verified.
  const personStatus = useMemo(
    () =>
      resolvePersonStatus({
        personStatus: accountData?.personStatus,
        status: accountData?.personStatus,
        documentPending: accountData?.documentPending ?? individualAccount.documentPending,
        pending: accountData?.pending ?? individualAccount.pending,
        verificationStatus:
          accountData?.verificationStatus ?? individualAccount.verificationStatus,
        individualAccountStatus: individualAccount.status,
      }),
    [
      accountData?.documentPending,
      accountData?.pending,
      accountData?.personStatus,
      accountData?.verificationStatus,
      individualAccount.documentPending,
      individualAccount.pending,
      individualAccount.verificationStatus,
      individualAccount.status,
    ],
  );

  const isPersonVerified = isPersonStatusVerified(personStatus);
  // Show Conta Individualizada promo only when person status !== `verified`.
  const isKycPending = !isPersonVerified;

  return {
    ...individualAccount,
    personStatus,
    isPersonVerified,
    isKycPending,
    onboardingOpen,
    openOnboarding,
    closeOnboarding,
  };
};
